import { useQuery } from 'react-query';

import axiosClient from '@lib/utils/axiosClient';

const fetchPatientMessageTemplates = async () => {
  const response = await axiosClient.get('/patientMessageTemplates');
  return response.data;
};

export default function usePatientMessageTemplatesResource() {
  return useQuery('patientMessageTemplate', fetchPatientMessageTemplates);
}
